var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.dialogFormVisible,"width":_vm.dialog_width,"close-on-click-modal":false},on:{"update:visible":function($event){_vm.dialogFormVisible=$event},"close":_vm.exit}},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }